import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PortalLayout } from "@/components/layout/PortalLayout";
import { SectorBadge } from "@/components/Badges";
import api from "@/lib/api";

const COLUMNS = [
  ["sourcing", "Sourcing"], ["vetting", "Vetting"], ["underwriting", "Underwriting"],
  ["ic_review", "IC Review"], ["published", "Published"], ["archived", "Archived"],
];
const NEXT = { sourcing: "vetting", vetting: "underwriting", underwriting: "ic_review", ic_review: "published" };

export default function BridgePipeline() {
  const [board, setBoard] = useState({});
  const load = () => api.get("/bridge/pipeline").then((r) => setBoard(r.data));
  useEffect(() => { load(); }, []);
  const move = async (id, stage) => {
    try { await api.post(`/bridge/deals/${id}/move`, { stage }); load(); }
    catch (e) { toast.error("Failed"); }
  };
  return (
    <PortalLayout title="Pipeline">
      <p className="text-sm text-muted-foreground mb-6">Kanban view of every deal across the sourcing lifecycle.</p>
      <div className="flex gap-4 overflow-x-auto pb-4" data-testid="bridge-kanban-board">
        {COLUMNS.map(([key, label]) => (
          <div key={key} data-testid="bridge-kanban-column" className="min-w-[280px] max-w-[300px] rounded-2xl bg-[hsl(var(--pdg-charcoal))] border border-border flex-shrink-0">
            <div className="sticky top-0 p-4 border-b border-border flex items-center justify-between">
              <span className="text-sm text-foreground">{label}</span>
              <span className="text-xs text-muted-foreground">{(board[key] || []).length}</span>
            </div>
            <div className="p-3 space-y-3 min-h-[120px]">
              {(board[key] || []).map((d) => (
                <div key={d.id} data-testid="bridge-kanban-card" className="pdg-glass rounded-xl p-4">
                  <SectorBadge sector={d.sector} />
                  <h4 className="mt-2 text-sm text-foreground leading-snug">{d.title}</h4>
                  <div className="text-xs text-muted-foreground mt-1">{d.geography} &middot; {d.size_range}</div>
                  {NEXT[key] && (
                    <button onClick={() => move(d.id, NEXT[key])} className="mt-3 text-xs text-[hsl(var(--pdg-gold))] hover:underline">Advance to {NEXT[key].replace("_", " ")} →</button>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </PortalLayout>
  );
}
